import { Link } from 'react-router-dom';
import { categoryNames } from '@/mocks/movies';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.href
      ? { '@id': `https://oil-zero.cn${item.href}`, name: item.label }
      : { name: item.label },
  }));

  return (
    <>
      <nav aria-label="面包屑导航" className="py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-1.5 text-foreground-600">/</span>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-300 whitespace-nowrap">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: schemaItems,
          }),
        }}
      />
    </>
  );
}